import { useEffect, useState, useCallback, useMemo } from "react";
import WebSocketManager from "../../../ws/client";

export function useProductLiveUpdate(initialProduct) {
    const [liveProduct, setLiveProduct] = useState(initialProduct);

    useEffect(() => {
        setLiveProduct(initialProduct);
    }, [initialProduct]);

    const productId = initialProduct?.product_id;

    const topic = useMemo(() => {
        if (!productId) return null;
        return `/topic/product-${productId}`;
    }, [productId]);

    const handleMessage = useCallback((event) => {
        try {
            const { type, payload } = event;

            if (type === "UPDATED" && payload) {
                setLiveProduct(payload);
            }

        } catch (err) {
            console.error("Erro ao processar update live do produto:", err);
        }
    }, []);

    useEffect(() => {

        if (!topic) return;

        WebSocketManager.subscribe(topic, handleMessage);

        return () => {
            WebSocketManager.unsubscribe(topic);
        };

    }, [topic, handleMessage]);

    return liveProduct;
}